import { CommunityChannelMemberStatusEnumItem } from '@ps/api/types';

export const CommunityChannelMemberStatus =
  CommunityChannelMemberStatusEnumItem;
export type CommunityChannelMemberStatus =
  (typeof CommunityChannelMemberStatus)[keyof typeof CommunityChannelMemberStatus];
